import { Component, Input, AfterContentInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmissionFile } from '../../models/evaluation.model';
import { AnnotatedTextComponent } from '../annotated-text/annotated-text.component';

@Component({
	selector: 'app-file-viewer',
	standalone: true,
	imports: [CommonModule, AnnotatedTextComponent],
	templateUrl: './file-viewer.component.html',
	styleUrls: ['./file-viewer.component.scss'],
})
export class FileViewerComponent implements AfterContentInit {
	@Input() files: SubmissionFile[] = [];
	@Input() activeAspectIds: string[] = [];
	selectedFile: SubmissionFile | null = null;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['activeAspectIds']) {
			this.identifyDocumentsWithEvidence();
		}
	}

	identifyDocumentsWithEvidence() {
		const parser = new DOMParser();
		this.files.forEach(file => {
			if (file.annotatedText) {
				const doc = parser.parseFromString(file.annotatedText, 'text/html');
				let hasAspect = false;
				for (const aspectId of this.activeAspectIds) {
					hasAspect = !!doc.querySelector(`[data-factorid="${aspectId}"]`);
					if (hasAspect) {
						break;
					}
				}
				file.hasEvidence = hasAspect;
			}
		});
	}

	selectFile(file: SubmissionFile): void {
		this.selectedFile = file;
	}

	ngAfterContentInit() {
		if (this.files.length > 0) {
			this.selectFile(this.files[0]);
		}
	}
}
